import cartFields from './cartFields.fragment'

/** GraphQL query to remove a coupon from a cart */
export default `
  mutation removeCouponFromCart($input: RemoveCouponFromCartInput) {
    removeCouponFromCart(input: $input) {
      cart {
          ${cartFields}
      }
    }
  }
  
`
